// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file remote_management_service.proto (package cuda_learning, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CheckAcceleratorHealthRequest, CheckAcceleratorHealthResponse, MonitorJetsonNanoRequest, MonitorJetsonNanoResponse, StartJetsonNanoRequest, StartJetsonNanoResponse } from "./remote_management_service_pb.js";
import { MethodIdempotency, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service cuda_learning.RemoteManagementService
 */
export const RemoteManagementService = {
  typeName: "cuda_learning.RemoteManagementService",
  methods: {
    /**
     * @generated from rpc cuda_learning.RemoteManagementService.StartJetsonNano
     */
    startJetsonNano: {
      name: "StartJetsonNano",
      I: StartJetsonNanoRequest,
      O: StartJetsonNanoResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc cuda_learning.RemoteManagementService.CheckAcceleratorHealth
     */
    checkAcceleratorHealth: {
      name: "CheckAcceleratorHealth",
      I: CheckAcceleratorHealthRequest,
      O: CheckAcceleratorHealthResponse,
      kind: MethodKind.Unary,
      idempotency: MethodIdempotency.NoSideEffects,
    },
    /**
     * @generated from rpc cuda_learning.RemoteManagementService.MonitorJetsonNano
     */
    monitorJetsonNano: {
      name: "MonitorJetsonNano",
      I: MonitorJetsonNanoRequest,
      O: MonitorJetsonNanoResponse,
      kind: MethodKind.ServerStreaming,
    },
  }
} as const;

